import { Routes, Route, Navigate } from 'react-router-dom'
import Landing from '@/pages/Landing'
import Login from '@/pages/Login'
import Register from '@/pages/Register'
import Onboarding from '@/pages/Onboarding'
import Dashboard from '@/pages/Dashboard'
import Search from '@/pages/Search'
import Plan from '@/pages/Plan'
import { useSession } from '@/store/session'

/**
 * Router principal del frontend MapeoData.
 *
 * Estructura:
 * - `/` → Landing pública pre-registro (planes hardcoded DEC-026, KISS YAGNI).
 * - `/login`, `/registro` → flujo auth público (GoTrue MapeoData DEC-003).
 * - `/onboarding` → asignación plan Free inicial post-registro (autenticado).
 * - `/app/*` → app autenticada (dashboard + búsqueda + resultados + export +
 *   plan/cupos). Cualquier ruta `/app/*` sin sesión activa redirige a /login.
 *
 * Versionado: consume `/api/v1/*` del backend (DEC-010) vía cliente HTTP
 * en `src/lib/api.ts`. Sin v1 = sin contrato.
 */

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const session = useSession((s) => s.session)
  if (!session) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      {/* Públicas */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/registro" element={<Register />} />

      {/* Autenticadas */}
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <Onboarding />
          </ProtectedRoute>
        }
      />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/busqueda"
        element={
          <ProtectedRoute>
            <Search />
          </ProtectedRoute>
        }
      />
      {/* Rutas /app/resultados y /app/export retiradas en T-016:
          la bandeja de leads + descargas viven inline en Búsqueda. */}
      <Route
        path="/app/plan"
        element={
          <ProtectedRoute>
            <Plan />
          </ProtectedRoute>
        }
      />

      {/* Catch-all → landing */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
